export default "__VITE_ASSET__CTrnAeMK__"